module.exports = __webpack_public_path__ + "static/media/metaImage.4b15c7f4.png";